import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { MdOutlineVisibilityOff, MdOutlineVisibility } from 'react-icons/md';
import { FaChevronLeft} from "react-icons/fa";
import { useState, useContext, useEffect } from 'react';
import { colors } from "../../../../theme/theme";

//types
import { CreateAccountProps } from "../../../@types";
import { CREATE_ACCOUNT_STEPS } from "../../../@enums";
import { IUser } from "../../../models/IUser";

//services
import { sendActivationCode } from "../../../services/create-account/create-account.service";

//components
import { toast } from "react-toastify";
import { Button, Container, Row, Col, Form, Stack, Spinner } from 'react-bootstrap';
import { Illustration } from "../styled"
import logo from "../../../../assets/img/logo.svg";
import logoWhite from "../../../../assets/img/logo-white.svg";
import cadastroIllustration from "../../../../assets/img/cadastro-illustration.png";
import finishedIllustration from "../../../../assets/img/finished-register-illustration.png";
import SystemContext from "../../../../context/systemContext/context";
import Error from "../../../components/Error";
import { VerifyCode } from "./components/VerifyCode";
import { Modal } from "../../../components/modal";
import { getPrivacyPolitics, getServiceTerms } from "../../../services/manager/admin/settings.service";
import { useHistory } from "react-router-dom";
import PasswordStrengthBar from "react-password-strength-bar";
import { classNames } from "primereact/utils";

const validationSchema = Yup.object({
  user: Yup.string().required("Este campo é obrigatório"),
  email: Yup.string().email('E-mail inválido').required("Este campo é obrigatório"),
  password: Yup.string().required("Este campo é obrigatório"),
  privacy_policy: Yup.boolean().required("Este campo é obrigatório.").oneOf([true], "Este campo é obrigatório."),
}).required();

const CreateAccount = (): JSX.Element => {
  const history = useHistory();
  const { systemConfig } = useContext(SystemContext)
  const { t: translation } = useTranslation();
  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm<CreateAccountProps>({ resolver: yupResolver(validationSchema) });

  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [strengthPassword, setStrengthPassword] = useState<number>(0);
  const [hasAcceptedPolicy, setHasAcceptedPolicy] = useState<boolean>(false);
  const [disableRegisterButton, setDisableRegisterButton] = useState<boolean>(true);
  const [step, setStep] = useState<number>(CREATE_ACCOUNT_STEPS.createAccount);
  const [user, setUser] = useState<IUser>({
    name: "",
    username: "",
    company: "",
    job: "",
    phone: "",
    email: "",
    password: "",
    is_whatsapp: false,
    is_staff: false,
    is_active: true,

  });

  const [showModalPrivacy, setShowModalPrivacy] = useState<boolean>(false)
  const [showModalTerms, setShowModalTerms] = useState<boolean>(false)
  const [haveToAcceptTerms, setHaveToAcceptTerms] = useState<boolean>(false)
  const [haveToAcceptPrivacy, setHaveToAcceptPrivacy] = useState<boolean>(false)
  const [privacyPolitics, setPrivacyPolitics] = useState<any>()
  const [terms, setTerms] = useState<any>()

  const onSubmit = (_user: CreateAccountProps) => {
    if (strengthPassword < 3) {
      setError('password', { type: 'custom', message: '' })
      return
    }

    setLoading(true);

    let params = {
      name: _user.user,
      username: _user.user,
      company: _user.company,
      job: _user.companyPosition,
      phone: _user.phone,
      email: _user.email,
      password: _user.password,
      is_whatsapp: false,
      is_staff: false,
      is_active: true,
      privacy_policy: hasAcceptedPolicy,
      service_term: hasAcceptedPolicy,
    }

    setUser(params)

    sendActivationCode(params.email, params.name).then(() => {
      setStep(CREATE_ACCOUNT_STEPS.verifyCode);
    }).catch((error) => {
      if (error?.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Ocorreu um erro ao enviar o código de verificação');
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  const handleAcceptTerms = (e: any) => {
    setHasAcceptedPolicy(e.target.checked)
    if (haveToAcceptTerms && haveToAcceptPrivacy) {
      setDisableRegisterButton(!e.target.checked)
    }
  }

  const handleRedirectToLogin = () => {
    window.location.href = '/login'
  }

  const handleChangeScore = (score: any, feedback: any) => {
    setStrengthPassword(score)
  }

  useEffect(() => {
    let requiredPrivacy = false;
    let requiredterms = false;

    getPrivacyPolitics().then((politics: any) => {
      setPrivacyPolitics(politics.body)
      setHaveToAcceptPrivacy(politics.is_required)
      requiredPrivacy = politics.is_required
    })

    getServiceTerms().then((_terms: any) => {
      setTerms(_terms.body)
      setHaveToAcceptTerms(_terms.is_required)
      requiredterms = _terms.is_required
      if (!requiredPrivacy || !requiredterms) {
        setDisableRegisterButton(false)
      }
    })
  }, [])

  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Container fluid>
      <Row className="row-card-login">
        <div className="back-auth-div">
          <span className="back-auth-button" onClick={() => history.push("/login")}>
            <FaChevronLeft size="16" style={{ marginRight: "8px", marginBottom: "2px" }} /> <span className="font-16"><b>Voltar</b></span>
          </span>
        </div>
        <Col xs={'auto'} lg={6} xl={7} xxl={8} className="p-0 vh-100 d-flex justify-content-center align-items-center">
          <Row className="row-illustration-login">
            <Col xs={12} className="vh-50 illustration">
              <Illustration image={step === CREATE_ACCOUNT_STEPS.finishRegister ? finishedIllustration : cadastroIllustration} />
            </Col>
            <Col xs={12} className="text-center text-welcome">
              <h3 className="text-white"><b>{step === CREATE_ACCOUNT_STEPS.finishRegister ? translation('login.congratulations') : translation('login.register')}</b></h3>
              <h5 className="text-white">{step === CREATE_ACCOUNT_STEPS.finishRegister ? translation('login.descriptionFinishedRegister') : translation('login.registerDescription')}</h5>
            </Col>
          </Row>
        </Col>
        <Col className={`card-login ${step === CREATE_ACCOUNT_STEPS.createAccount ? "d-flex align-items-center justify-content-center" : ""}`}>
          <div className="wrapper-login">
            {
              step === CREATE_ACCOUNT_STEPS.verifyCode ? (
                <VerifyCode user={user} setStep={setStep} />
              ) : step === CREATE_ACCOUNT_STEPS.finishRegister ? (
                <Row>
                  <Col className="col-12 text-center mb-2rem logo-form">
                    {systemConfig.theme === "light" ? (<img src={logo} alt="Logo" height={65} />) : (<img src={logoWhite} alt="Logo" height={65} />)}
                  </Col>
                  <Col className="col-12 text-center mb-3">
                    <p className="text-black mb-3" style={{ fontSize: '18px' }}><b>{translation('login.finishedRegister')}</b></p>
                    <Stack gap={4} className="col-12 col-md-8 mx-auto text-center">
                      <p className="text-darker-grey mb-0" style={{ fontSize: '16px', lineHeight: '19.2px'}}>{translation('login.subFinishedRegister')}</p>
                    </Stack>
                  </Col>
                  <Stack gap={4} className="col-12 mx-auto text-center justify-content-center mt-3">
                    <Button variant="primary" type="button" className="btn-rounded" style={{ height: "48px"}} onClick={() => handleRedirectToLogin()}><b>{translation('login.login').toUpperCase()}</b></Button>
                  </Stack>
                </Row>
              ) : (
                <Form className="w-100 form-auth" onSubmit={handleSubmit(onSubmit)}>
                  <Col className="text-center mb-2rem logo-form">
                    {systemConfig.theme === "light" ? (<img src={logo} alt="Logo" height={65} />) : (<img src={logoWhite} alt="Logo" height={65} />)}
                  </Col>

                  <Form.Group className="mb-2rem">
                    <Form.Label className="text-black"><b>{translation('lead.username')}</b></Form.Label>
                    <Form.Control 
                      maxLength={40} 
                      type="text" 
                      placeholder={translation('lead.username')} 
                      {...register("user", { required: true })} 
                    />
                    {errors.user ? (<div className="w-100"> <Error>{errors.user?.message}</Error> </div>) : ""}
                  </Form.Group>

                  <Form.Group className="mb-2rem">
                    <Form.Label className="text-black"><b>{translation('login.email')}</b></Form.Label>
                    <Form.Control 
                      type="text" 
                      placeholder={translation('login.email')}
                      aria-label={translation('login.email')}
                      {...register("email", { required: true })} 
                    />
                    {errors.email ? (<div className="w-100"> <Error>{errors.email?.message}</Error> </div>) : ""}
                  </Form.Group>

                  <Form.Group className="mb-2rem position-relative">
                    <Form.Label className="text-black"><b>{translation('login.password')}</b></Form.Label>
                    <Form.Control 
                      type={showPassword ? "text" : "password"} 
                      value={password}
                      placeholder={translation('login.password')}
                      aria-label={translation('login.password')}
                      onChange={(e: any) => {
                        setValue('password', e.target.value)
                        setPassword(e.target.value)
                      }}
                    />
                    <span className={"eye-password-icon-login"}>
                      {
                        showPassword ? (
                          <MdOutlineVisibility style={{ width: "22px", height: "22px", color: colors.greyscale.black }} onClick={() => setShowPassword(false)} />
                        ) : (
                          <MdOutlineVisibilityOff style={{ width: "22px", height: "22px", color: colors.greyscale.black }} onClick={() => setShowPassword(true)} />
                        )
                      }
                    </span>
                    {
                      password &&
                      <PasswordStrengthBar 
                        password={password} minLength={8} 
                        shortScoreWord={'Muito curto'} 
                        barColors={['#ddd', '#E02F3E', '#FF9900', '#666CFF', '#20A85D']} 
                        scoreWords={['Fraca', 'Fraca', 'Média', 'Boa', 'Forte']}
                        onChangeScore={handleChangeScore}
                      />
                    }

                    {errors.password?.type === 'required' ? (<div className="w-100"> <Error>{errors.password?.message}</Error> </div>) : ""}
                    
                    {
                      password &&
                      <>
                        {
                          errors.password?.type === 'custom' ? (
                            <div className="w-100"> <Error>Use no mínimo 8 caracteres maiúsculos e minúsculos, números e caracteres especiais ( ! @ # $ % ^ & * )</Error> </div>
                          ) : (
                            <p className={classNames({ 'mt-1': true, 'error': errors.password?.type === 'custom', 'font-14': true })}>Use no mínimo 8 caracteres maiúsculos e minúsculos, números e caracteres especiais ( ! @ # $ % ^ & * )</p>
                          )
                        }
                      </>
                    }
                  </Form.Group>

                  <Form.Check type="checkbox" id="terms">
                    <Form.Check.Input type='checkbox' isValid {...register("privacy_policy", { required: true })} onChange={(e: any) => handleAcceptTerms(e)}  />
                    <Form.Check.Label style={{color: '#A5A5A5', fontSize: '12px'}}>
                      Eu aceito os&nbsp;                      
                      <div style={{ display: 'inline-block', cursor:'pointer', fontWeight: 600 }} onClick={(event: any) => {event.preventDefault(); event.stopPropagation(); setShowModalTerms(true)}}>
                        Termos de Serviços 
                      </div>
                      &nbsp;e&nbsp;
                      <div style={{ display: 'inline-block', cursor:'pointer', fontWeight: 600 }} onClick={(event: any) => { event.preventDefault(); event.stopPropagation(); setShowModalPrivacy(true)}}>
                        Políticas de Privacidade
                      </div>
                    </Form.Check.Label>
                  </Form.Check>
                  {errors.privacy_policy ? (<div className="w-100"> <Error>{errors.privacy_policy?.message}</Error> </div>) : ""}

                  <Stack gap={5} className="col-12 mx-auto text-center mb-2rem mt-3">
                    <Button variant="primary" type="submit" className="btn-rounded" disabled={disableRegisterButton}><b>{translation('login.createAccount').toUpperCase()}</b></Button>
                    <p className="text-black font-16 mb-0">{translation('login.haveAccount')} &nbsp;<b><a href="#" onClick={() => history.push('/login')} className="text-blueberry">{translation('login.login')}</a></b></p>
                  </Stack>
                </Form>
              )
            }
          </div>
        </Col>
      </Row>

      <Modal
        headerTitle="Politica de Privacidade"
        showFooter={false}
        submitButtonText={translation('remove')}
        show={showModalPrivacy}
        onHide={() => setShowModalPrivacy(false)}
        variant="form-modal-default"
        loading={false}
      >
        <div dangerouslySetInnerHTML={{ __html: privacyPolitics }}></div>
      </Modal>

      <Modal
        headerTitle="Termos de Uso"
        showFooter={false}
        submitButtonText={translation('remove')}
        show={showModalTerms}
        onHide={() => setShowModalTerms(false)}
        variant="form-modal-default"
        loading={false}
      >
        <div dangerouslySetInnerHTML={{ __html: terms }}></div>
      </Modal>
    </Container>
  )
}

export default CreateAccount;
